import React, { useEffect } from 'react'
import './assets/main.scss';
import './i18n';
import router from './routes/index'
import keycloak from './keycloak';
import {ReactKeycloakProvider} from "@react-keycloak/web";
import {
  RouterProvider,
} from "react-router-dom";
import {ConfigProvider} from "antd";
import ruLocale from 'antd/locale/ru_RU';
import enLocale from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import { useTranslation } from 'react-i18next'

const isRu = process.env.REACT_APP_LANG === 'ru'

if (isRu) {
  dayjs.locale('ru-ru')
}

const locale = isRu ? ruLocale : enLocale

const keycloakOptions = {
  onLoad: 'login-required'
}

const App: React.FC = () => {
  const {t} = useTranslation();
  useEffect(() => {
    document.title = t('list.title');
  }, []);

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      LoadingComponent={<div>Loading...</div>}
      initOptions={keycloakOptions}
    >
      <ConfigProvider
        theme={{
          components: {
            Layout: {
              headerBg: '#fff',
              siderBg: '#fff',
              fontFamily: 'Open Sans',
              fontFamilyCode: 'Open Sans',
            },
          },
        }}
        locale={locale}
      >
        <RouterProvider router={router}/>
      </ConfigProvider>
    </ReactKeycloakProvider>
  );
}

export default App;
